import { Injectable } from "@angular/core";
import { BehaviorSubject, Observable } from "rxjs";
import { AddUser } from "../models/adduser";
import { ConfigService, HttpWrapperService } from '@gbs-platform-client/fwk-core'
import { map } from "rxjs/operators";
import { HttpClient, JsonpClientBackend } from "@angular/common/http";
import { UserType } from "../models/adduser";
import { Emp } from "../models/adduser"; 
@Injectable({
  providedIn: 'root'
})
export class AddUserService {
  apiEndpoint: string;
  baseApiUrl: any;
  apiUniqueId: string = 'authenticate/ret/hCw230b862-99250-4f71-a1271-f8bqxvvbner121967d35d/candidate/AOaemvOPybXzswaLnMtcT3gMn3sp3/';

  constructor(private httpService: HttpWrapperService, private http: HttpClient,
    private configService: ConfigService
  ) {
    this.apiEndpoint = this.configService.getConfigValue('apiEndpoint');
    this.apiEndpoint += this.apiUniqueId;
  }
 
  getGeneralpreferencesByName(Generalpreference_Name?: string): Observable<any> {
    return this.httpService.get(this.apiEndpoint + 'getGeneralpreferencesByName?GeneralpreferenceName='+ (Generalpreference_Name ? Generalpreference_Name : '')).pipe(map((result: any) => {
      if (result.Success) {
        return result.Data;
      } else {
        return [];
      }      
    }));
  } 
  getAllAdduser(): Observable<Array<AddUser>> { 
    return this.httpService.get(this.apiEndpoint + 'getAllAdduser').pipe(map((result: any) => {      
      if (result.Success) {
        return result.Data;
      } else {
        return [];
      }
    }));
  }
  viewUser(UserName?: string): Observable<Array<AddUser>> {
    return this.httpService.get(this.apiEndpoint + 'viewUser/' + (UserName ? UserName : '')).pipe(map((result: any) => {
      if (result.Success) {
        return result.Data;
      } else {
        return [];
      }
    }));
  }
  saveUser(entities: AddUser): Observable<any> { 
    return this.httpService.post(this.apiEndpoint + 'register/', entities).pipe(map((result: any) => {
      if (result.Success) { 
        return result.Data;
      } else {
        return [];
      }
    }));
  }

  deleteUser(AddUserID?: number): Observable<any> {
    return this.httpService.post(this.apiEndpoint + 'deleteUser/' + (AddUserID ? AddUserID : ''), AddUserID).pipe(map((result: any) => {
      if (result.Success) {
        return result.Data;
      } else {
        return [];
      }
    }));
  }

  checkDuplication(UserName?: string,UserId?: number): Observable<any> {
    return this.httpService.get(this.apiEndpoint + 'checkDuplication?AddUserName=' + (UserName ? UserName : '')+ '&AddUserid=' + (UserId ? UserId : 0)).pipe(map((result: any) => {
        return result; 
    }));
  }
  checkEmail(Email?: string, UserId?: number): Observable<any> {
    return this.httpService.get(this.apiEndpoint + 'checkEmail?Email=' + (Email ? Email : '')+ '&UserId=' + (UserId ? UserId : 0)).pipe(map((result: any) => {
      return result;
    })); 
  }

getusertype(): Observable<Array<UserType>> { 
  return this.httpService.get(this.apiEndpoint + 'getusertype').pipe(map((result: any) => {      
    if (result.Success) {
      return result.Data;
    } else {
      return [];
    }
  }));
} 

}